@let currentAgencyRole = $currentAgencyRole();
@let currentUser = $currentUser();
@let dashboardLink = ['/user', 'dashboard'];

<kendo-gridlayout
  class="context-panel-container"
  [cols]="['auto', 'auto']"
  [rows]="['1fr', '1fr']"
  [gap]="{ cols: 15, rows: 0 }"
  [align]="{ horizontal: 'end', vertical: 'middle' }">
  <kendo-gridlayout-item class="user-info-container" [col]="1" [row]="1">
    <kendo-stacklayout orientation="horizontal">
      @if ($isImpersonating()) {
        <button class="impersonation-btn" type="button" [title]="exitImpersonationText" (click)="onClick()">Impersonating</button>
      }
      <a class="profile-text" [routerLink]="dashboardLink">
        {{ currentUser?.fullname }}
      </a>
    </kendo-stacklayout>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item class="user-info-container" [col]="1" [row]="2">
    <a class="profile-text" [routerLink]="dashboardLink">
      {{ currentAgencyRole?.agency_name }}
    </a>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [col]="2" [row]="1" [colSpan]="1" [rowSpan]="2">
    <a class="profile-btn-container" [routerLink]="dashboardLink">
      <kendo-svg-icon class="profile-icon" alt="User Profile" [icon]="profileIcon" />
    </a>
  </kendo-gridlayout-item>
</kendo-gridlayout>
